var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrivacyBrowserGuardian(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 62,
    viewBox: "0 0 61 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3281 38.6563C10.3281 38.6563 12.8617 36.1228 20.4622 36.1228C28.0628 36.1228 33.1299 41.1899 40.7305 41.1899C48.3311 41.1899 50.8646 38.6563 50.8646 38.6563V8.25399C50.8646 8.25399 48.3311 10.7875 40.7305 10.7875C33.1299 10.7875 28.0628 5.72046 20.4622 5.72046C12.8617 5.72046 10.3281 8.25399 10.3281 8.25399V38.6563Z",
    stroke: "white",
    strokeWidth: 5.06706,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3281 56.3911V38.6564",
    stroke: "white",
    strokeWidth: 5.06706,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacyBrowserGuardian);
export default __webpack_public_path__ + "static/media/privacy-browser-guardian.1be0126e8ce51fa61bb804bf7be265e7.svg";
export { ForwardRef as ReactComponent };